export default "__VITE_ASSET__810301eb__$_?react__"